// generated by recipeyak.api.base.codegen
import { http } from "@/apiClient"

export function inviteList() {
  return http<
    Array<{
      id: number
      created: string
      status: "accepted" | "declined" | "open"
      team: {
        id: number
        name: string
      }
      creator: {
        id: number
        email: string
        avatar_url: string
      }
    }>
  >({
    url: "/api/v1/invites/",
    method: "get",
  })
}
